import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *apolloMutation(mutation, $completion) {
  return yield* this.get_apolloClient_ck0qwt_k$().mutation_qix1z8_k$(mutation).addHttpHeader_irkgza_k$('Authorization', 'Bearer ' + (yield* this.getIdToken_f0429n_k$($completion))).execute_ar693i_k$($completion);
}
function *apolloQuery(query, $completion) {
  return yield* this.get_apolloClient_ck0qwt_k$().query_jcptxn_k$(query).addHttpHeader_irkgza_k$('Authorization', 'Bearer ' + (yield* this.getIdToken_f0429n_k$($completion))).execute_ar693i_k$($completion);
}
var KtorQueryPerformerClass;
function KtorQueryPerformer() {
  if (KtorQueryPerformerClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'KtorQueryPerformer', VOID, VOID, VOID, [1, 0]);
    KtorQueryPerformerClass = $;
  }
  return KtorQueryPerformerClass;
}
//region block: exports
export {
  KtorQueryPerformer as KtorQueryPerformer3enpohylr2sy5,
  apolloMutation as apolloMutation268q7y4mm39s9,
  apolloQuery as apolloQuery3ui08pd477bo5,
};
//endregion

//# sourceMappingURL=KtorQueryPerformer.mjs.map
